"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.HeaderCard = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

require("antd/lib/collapse/style");

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _class;

var Panel = _collapse.default.Panel;
var headerPanelStyle = {
  background: "#f7f7f7",
  marginBottom: 24
};

var HeaderCard = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(HeaderCard, _Component);

  function HeaderCard(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = HeaderCard.prototype;

  _proto.render = function render() {
    var title = this.props.title;
    return _react.default.createElement(_collapse.default, {
      defaultActiveKey: [title],
      bordered: false
    }, _react.default.createElement(Panel, {
      header: _react.default.createElement("h3", null, title.toUpperCase()),
      key: title,
      style: headerPanelStyle
    }, this.props.children));
  };

  return HeaderCard;
}(_react.Component)) || _class;

exports.HeaderCard = HeaderCard;